/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamConstancyWorkResultDtoCreatorUser } from './BeamConstancyWorkResultDtoCreatorUser';
import {
    BeamConstancyWorkResultDtoCreatorUserFromJSON,
    BeamConstancyWorkResultDtoCreatorUserFromJSONTyped,
    BeamConstancyWorkResultDtoCreatorUserToJSON,
} from './BeamConstancyWorkResultDtoCreatorUser';
import type { DueState } from './DueState';
import {
    DueStateFromJSON,
    DueStateFromJSONTyped,
    DueStateToJSON,
} from './DueState';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';
import type { JobConfigurationDtoTargetSystem } from './JobConfigurationDtoTargetSystem';
import {
    JobConfigurationDtoTargetSystemFromJSON,
    JobConfigurationDtoTargetSystemFromJSONTyped,
    JobConfigurationDtoTargetSystemToJSON,
} from './JobConfigurationDtoTargetSystem';
import type { JobFrequency } from './JobFrequency';
import {
    JobFrequencyFromJSON,
    JobFrequencyFromJSONTyped,
    JobFrequencyToJSON,
} from './JobFrequency';
import type { JobOccurrenceDtoWorkProgressSummary } from './JobOccurrenceDtoWorkProgressSummary';
import {
    JobOccurrenceDtoWorkProgressSummaryFromJSON,
    JobOccurrenceDtoWorkProgressSummaryFromJSONTyped,
    JobOccurrenceDtoWorkProgressSummaryToJSON,
} from './JobOccurrenceDtoWorkProgressSummary';
import type { JobState } from './JobState';
import {
    JobStateFromJSON,
    JobStateFromJSONTyped,
    JobStateToJSON,
} from './JobState';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { ProtocolDto } from './ProtocolDto';
import {
    ProtocolDtoFromJSON,
    ProtocolDtoFromJSONTyped,
    ProtocolDtoToJSON,
} from './ProtocolDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { QaEquipmentCatalogDto } from './QaEquipmentCatalogDto';
import {
    QaEquipmentCatalogDtoFromJSON,
    QaEquipmentCatalogDtoFromJSONTyped,
    QaEquipmentCatalogDtoToJSON,
} from './QaEquipmentCatalogDto';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RoleCatalogDto } from './RoleCatalogDto';
import {
    RoleCatalogDtoFromJSON,
    RoleCatalogDtoFromJSONTyped,
    RoleCatalogDtoToJSON,
} from './RoleCatalogDto';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { WorkItemDto } from './WorkItemDto';
import {
    WorkItemDtoFromJSON,
    WorkItemDtoFromJSONTyped,
    WorkItemDtoToJSON,
} from './WorkItemDto';

/**
 * 
 * @export
 * @interface JobOccurrenceDto
 */
export interface JobOccurrenceDto {
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof JobOccurrenceDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof JobOccurrenceDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof JobOccurrenceDto
     */
    creatorUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof JobOccurrenceDto
     */
    lastModifierUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof JobOccurrenceDto
     */
    editingUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof JobOccurrenceDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof JobOccurrenceDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof JobOccurrenceDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {JobState}
     * @memberof JobOccurrenceDto
     */
    state?: JobState;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    jobConfigurationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    jobConfigurationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    jobConfigurationIuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    jobConfigurationDescription?: string | null;
    /**
     * 
     * @type {JobFrequency}
     * @memberof JobOccurrenceDto
     */
    frequency?: JobFrequency;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceDto
     */
    assignedUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceDto
     */
    assignedRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<UserCatalogDto>}
     * @memberof JobOccurrenceDto
     */
    assignedUsers?: Array<UserCatalogDto> | null;
    /**
     * 
     * @type {Array<RoleCatalogDto>}
     * @memberof JobOccurrenceDto
     */
    assignedRoles?: Array<RoleCatalogDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOccurrenceDto
     */
    assignedRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    reviewRequired?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceDto
     */
    reviewUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceDto
     */
    reviewRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<UserCatalogDto>}
     * @memberof JobOccurrenceDto
     */
    reviewUsers?: Array<UserCatalogDto> | null;
    /**
     * 
     * @type {Array<RoleCatalogDto>}
     * @memberof JobOccurrenceDto
     */
    reviewRoles?: Array<RoleCatalogDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOccurrenceDto
     */
    reviewRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    autoApprove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    wasAutoApproved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    approvalTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceDto
     */
    approverUserId?: number | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof JobOccurrenceDto
     */
    approverUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    targetSystemId?: string | null;
    /**
     * 
     * @type {JobConfigurationDtoTargetSystem}
     * @memberof JobOccurrenceDto
     */
    targetSystem?: JobConfigurationDtoTargetSystem | null;
    /**
     * 
     * @type {Array<QaEquipmentCatalogDto>}
     * @memberof JobOccurrenceDto
     */
    supportSystems?: Array<QaEquipmentCatalogDto> | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    timeZone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    executionAllDay?: boolean;
    /**
     * 
     * @type {DueState}
     * @memberof JobOccurrenceDto
     */
    dueState?: DueState;
    /**
     * 
     * @type {Array<WorkItemDto>}
     * @memberof JobOccurrenceDto
     */
    workItems?: Array<WorkItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    executionStarted?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    executionCompleted?: string | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof JobOccurrenceDto
     */
    executionCompletedByUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    executionStateChangedTime?: string | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof JobOccurrenceDto
     */
    executionStateChangedUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {JobOccurrenceDtoWorkProgressSummary}
     * @memberof JobOccurrenceDto
     */
    workProgressSummary?: JobOccurrenceDtoWorkProgressSummary | null;
    /**
     * 
     * @type {Array<ProtocolDto>}
     * @memberof JobOccurrenceDto
     */
    protocols?: Array<ProtocolDto> | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    $type?: JobOccurrenceDtoTypeEnum;
}


/**
 * @export
 */
export const JobOccurrenceDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoJobOccurrenceDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.JobOccurrenceDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type JobOccurrenceDtoTypeEnum = typeof JobOccurrenceDtoTypeEnum[keyof typeof JobOccurrenceDtoTypeEnum];


/**
 * Check if a given object implements the JobOccurrenceDto interface.
 */
export function instanceOfJobOccurrenceDto(value?: unknown): value is JobOccurrenceDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(JobOccurrenceDtoTypeEnum)[0];
}

export function JobOccurrenceDtoFromJSON(json: any): JobOccurrenceDto {
    return JobOccurrenceDtoFromJSONTyped(json, false);
}

export function JobOccurrenceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobOccurrenceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': !exists(json, 'state') ? undefined : JobStateFromJSON(json['state']),
        'jobConfigurationId': !exists(json, 'jobConfigurationId') ? undefined : json['jobConfigurationId'],
        'jobConfigurationName': !exists(json, 'jobConfigurationName') ? undefined : json['jobConfigurationName'],
        'jobConfigurationIuid': !exists(json, 'jobConfigurationIuid') ? undefined : json['jobConfigurationIuid'],
        'jobConfigurationDescription': !exists(json, 'jobConfigurationDescription') ? undefined : json['jobConfigurationDescription'],
        'frequency': !exists(json, 'frequency') ? undefined : JobFrequencyFromJSON(json['frequency']),
        'assignedUserIds': !exists(json, 'assignedUserIds') ? undefined : json['assignedUserIds'],
        'assignedRoleIds': !exists(json, 'assignedRoleIds') ? undefined : json['assignedRoleIds'],
        'assignedUsers': !exists(json, 'assignedUsers') ? undefined : (json['assignedUsers'] === null ? null : (json['assignedUsers'] as Array<any>).map(UserCatalogDtoFromJSON)),
        'assignedRoles': !exists(json, 'assignedRoles') ? undefined : (json['assignedRoles'] === null ? null : (json['assignedRoles'] as Array<any>).map(RoleCatalogDtoFromJSON)),
        'assignedRolesDisplayNames': !exists(json, 'assignedRolesDisplayNames') ? undefined : json['assignedRolesDisplayNames'],
        'reviewRequired': !exists(json, 'reviewRequired') ? undefined : json['reviewRequired'],
        'reviewUserIds': !exists(json, 'reviewUserIds') ? undefined : json['reviewUserIds'],
        'reviewRoleIds': !exists(json, 'reviewRoleIds') ? undefined : json['reviewRoleIds'],
        'reviewUsers': !exists(json, 'reviewUsers') ? undefined : (json['reviewUsers'] === null ? null : (json['reviewUsers'] as Array<any>).map(UserCatalogDtoFromJSON)),
        'reviewRoles': !exists(json, 'reviewRoles') ? undefined : (json['reviewRoles'] === null ? null : (json['reviewRoles'] as Array<any>).map(RoleCatalogDtoFromJSON)),
        'reviewRolesDisplayNames': !exists(json, 'reviewRolesDisplayNames') ? undefined : json['reviewRolesDisplayNames'],
        'autoApprove': !exists(json, 'autoApprove') ? undefined : json['autoApprove'],
        'wasAutoApproved': !exists(json, 'wasAutoApproved') ? undefined : json['wasAutoApproved'],
        'approvalTime': !exists(json, 'approvalTime') ? undefined : json['approvalTime'],
        'approverUserId': !exists(json, 'approverUserId') ? undefined : json['approverUserId'],
        'approverUser': !exists(json, 'approverUser') ? undefined : HistoryDtoUserFromJSON(json['approverUser']),
        'targetSystemId': !exists(json, 'targetSystemId') ? undefined : json['targetSystemId'],
        'targetSystem': !exists(json, 'targetSystem') ? undefined : JobConfigurationDtoTargetSystemFromJSON(json['targetSystem']),
        'supportSystems': !exists(json, 'supportSystems') ? undefined : (json['supportSystems'] === null ? null : (json['supportSystems'] as Array<any>).map(QaEquipmentCatalogDtoFromJSON)),
        'start': !exists(json, 'start') ? undefined : json['start'],
        'end': !exists(json, 'end') ? undefined : json['end'],
        'timeZone': !exists(json, 'timeZone') ? undefined : json['timeZone'],
        'executionAllDay': !exists(json, 'executionAllDay') ? undefined : json['executionAllDay'],
        'dueState': !exists(json, 'dueState') ? undefined : DueStateFromJSON(json['dueState']),
        'workItems': !exists(json, 'workItems') ? undefined : (json['workItems'] === null ? null : (json['workItems'] as Array<any>).map(WorkItemDtoFromJSON)),
        'executionStarted': !exists(json, 'executionStarted') ? undefined : json['executionStarted'],
        'executionCompleted': !exists(json, 'executionCompleted') ? undefined : json['executionCompleted'],
        'executionCompletedByUser': !exists(json, 'executionCompletedByUser') ? undefined : HistoryDtoUserFromJSON(json['executionCompletedByUser']),
        'executionStateChangedTime': !exists(json, 'executionStateChangedTime') ? undefined : json['executionStateChangedTime'],
        'executionStateChangedUser': !exists(json, 'executionStateChangedUser') ? undefined : HistoryDtoUserFromJSON(json['executionStateChangedUser']),
        'workProgressSummary': !exists(json, 'workProgressSummary') ? undefined : JobOccurrenceDtoWorkProgressSummaryFromJSON(json['workProgressSummary']),
        'protocols': !exists(json, 'protocols') ? undefined : (json['protocols'] === null ? null : (json['protocols'] as Array<any>).map(ProtocolDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function JobOccurrenceDtoToJSON(value?: JobOccurrenceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value.creatorUser),
        'lastModifierUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value.lastModifierUser),
        'editingUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': JobStateToJSON(value.state),
        'jobConfigurationId': value.jobConfigurationId,
        'jobConfigurationName': value.jobConfigurationName,
        'jobConfigurationIuid': value.jobConfigurationIuid,
        'jobConfigurationDescription': value.jobConfigurationDescription,
        'frequency': JobFrequencyToJSON(value.frequency),
        'assignedUserIds': value.assignedUserIds,
        'assignedRoleIds': value.assignedRoleIds,
        'assignedUsers': value.assignedUsers === undefined ? undefined : (value.assignedUsers === null ? null : (value.assignedUsers as Array<any>).map(UserCatalogDtoToJSON)),
        'assignedRoles': value.assignedRoles === undefined ? undefined : (value.assignedRoles === null ? null : (value.assignedRoles as Array<any>).map(RoleCatalogDtoToJSON)),
        'assignedRolesDisplayNames': value.assignedRolesDisplayNames,
        'reviewRequired': value.reviewRequired,
        'reviewUserIds': value.reviewUserIds,
        'reviewRoleIds': value.reviewRoleIds,
        'reviewUsers': value.reviewUsers === undefined ? undefined : (value.reviewUsers === null ? null : (value.reviewUsers as Array<any>).map(UserCatalogDtoToJSON)),
        'reviewRoles': value.reviewRoles === undefined ? undefined : (value.reviewRoles === null ? null : (value.reviewRoles as Array<any>).map(RoleCatalogDtoToJSON)),
        'reviewRolesDisplayNames': value.reviewRolesDisplayNames,
        'autoApprove': value.autoApprove,
        'wasAutoApproved': value.wasAutoApproved,
        'approvalTime': value.approvalTime,
        'approverUserId': value.approverUserId,
        'approverUser': HistoryDtoUserToJSON(value.approverUser),
        'targetSystemId': value.targetSystemId,
        'targetSystem': JobConfigurationDtoTargetSystemToJSON(value.targetSystem),
        'supportSystems': value.supportSystems === undefined ? undefined : (value.supportSystems === null ? null : (value.supportSystems as Array<any>).map(QaEquipmentCatalogDtoToJSON)),
        'start': value.start,
        'end': value.end,
        'timeZone': value.timeZone,
        'executionAllDay': value.executionAllDay,
        'dueState': DueStateToJSON(value.dueState),
        'workItems': value.workItems === undefined ? undefined : (value.workItems === null ? null : (value.workItems as Array<any>).map(WorkItemDtoToJSON)),
        'executionStarted': value.executionStarted,
        'executionCompleted': value.executionCompleted,
        'executionCompletedByUser': HistoryDtoUserToJSON(value.executionCompletedByUser),
        'executionStateChangedTime': value.executionStateChangedTime,
        'executionStateChangedUser': HistoryDtoUserToJSON(value.executionStateChangedUser),
        'workProgressSummary': JobOccurrenceDtoWorkProgressSummaryToJSON(value.workProgressSummary),
        'protocols': value.protocols === undefined ? undefined : (value.protocols === null ? null : (value.protocols as Array<any>).map(ProtocolDtoToJSON)),
        '$type': value.$type,
    });
}

